import { Form, Link, redirect, useActionData } from 'react-router-dom';

import axios from 'axios';
import Alert from '../components/Alert';
import { useApplicationStore } from '../stores/applicationStore';
import { useUserStore } from '../stores/userStore';

export async function action({ request /*params */ }) {
	const { signIn } = useUserStore.getState();
	const formData = await request.formData();
	const data = Object.fromEntries(formData);
	try {
		await signIn(data);
		if (useApplicationStore.getState().program?.id) {
			return redirect('/submitRequest');
		} else {
			const { user } = useUserStore.getState();
			const { data } = await axios.get(
				`/clients/${user.id}/security-questions-exists`,
			);
			if (!data?.questions_exist) {
				return redirect('/completeRegistration');
			}
		}
		return redirect('/home');
	} catch (err) {
		return err?.response?.data?.error;
	}
}

const Login = () => {
	const loginError = useActionData();
	return (
		<div className="justify-center py-12 page">
			<div className="text-center sm:mx-auto sm:w-full sm:max-w-sm">
				<h2>Sign in to your account</h2>
			</div>
			<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
				<Form className="space-y-6" method="post">
					{loginError?.code === 'LOGIN_FAILED' && (
						<Alert message="Invalid username or password, please try again." />
					)}
					{loginError?.code === 'USERNAME_EMAIL_REQUIRED' && (
						<Alert message="Username is required." />
					)}
					{loginError?.code === 'UNKNOWN' && (
						<Alert message="Unable to log in at this time. Please try again later." />
					)}
					<div className="form-control">
						<label htmlFor="username" className="label label-text">
							Username
						</label>
						<input
							id="username"
							name="username"
							type="text"
							autoComplete="username"
							required
							className="w-full input input-sm input-bordered"
						/>
					</div>

					<div className="form-control">
						<div className="flex items-center justify-between">
							<label htmlFor="password" className="label label-text">
								Password
							</label>
							<div>
								<Link
									to="/forgotPassword"
									className="link link-primary label-text"
								>
									Forgot password?
								</Link>
							</div>
						</div>
						<input
							id="password"
							name="password"
							type="password"
							autoComplete="current-password"
							required
							className="w-full input input-sm input-bordered"
						/>
					</div>

					<div>
						<button className="text-white btn btn-primary btn-sm btn-block">
							Sign In
						</button>
					</div>
				</Form>

				<p className="mt-10 text-sm text-center text-gray-600">
					No account?{' '}
					<Link to="/register" className="link link-primary">
						Register Now
					</Link>
				</p>
				<p className="mt-8 text-xs text-center text-gray-400">
					&copy; {new Date().getFullYear()} Tandem, Build{' '}
					{process.env.BITBUCKET_BUILD_NUMBER || 'LOCAL'}
				</p>
			</div>
		</div>
	);
};

export default Login;
